import { render } from "./Gottesdienst.vue?vue&type=template&id=e8d6a712"
import script from "./Gottesdienst.vue?vue&type=script&lang=js"
export * from "./Gottesdienst.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__